import React, { useState, useEffect } from "react";
import instance from "../instance";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Customer.css";

const NewCustomer = () => {
  const [formattedDate, setFormattedDate] = useState("");
  const [customerData, setCustomerData] = useState({
    Code: "",
    Date: new Date(),
    StartDate: new Date(),
    Name: "",
    NameOwner: "",
    Phone: "",
    City: "",
    Governorate: "",
    WifiName: "",
    WifiPassword: "",
    Latitude: "",
    Longitude: "",
    ServerStatus: "New",
    ManagementSite: "https://my.contabo.com/",
    ServerLocation: "England",
    NameServer: "OwlUK",
    Status: "Online",
    ServerType: "Dedicated Server Hosting",
    IP: "",
    IPVPN: "",
    ServerSystem: "WindowsServer2022",
    UserSystem: "administrator",
    PasswordSystem: "",
    DataEncryption: "true",
    DatabaseName: "",
    SQLUser: "sa",
    SQLPassword: "",
    TrustedConnection: "true",
    VersionBack: "OWLB121220250",
    VersionFront: "OWLF121220250",
    UrlFront: "https://.owltecheg.com",
    UrlBack: "https://backendowls.owltecheg.com",
    SuperAdmin: "01006375557",
    PasswordSuperAdmin: "",
    BackupAuto: "true",
    BackupManualMaxNumber: "3",
    BackupManualPath: "D:/OwlTechEG.com/BackupOwl/BackupCustomers/",
    BackupAutoPath: "D:/OwlTechEG.com/BackupOwl",
    PriceType: "Silver",
    Price: "780",
    PaymentDate: new Date(),
    SystemPrice: "",
    Prepaid: "",
    MonthlyFees: "",
    Notes: "",
    SpeechStartDate: null,
    SpeechEndDate: null,
    SpeechIsActive: false,
    SpeechPrice: "1000",
  });

  const [passwordVisibility, setPasswordVisibility] = useState({
    WifiPassword: false,
    PasswordSystem: false,
    PasswordSQL: false,
    PasswordSuperAdmin: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const nextMonthDate = new Date(currentDate);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setFormattedDate(formattedDate);

    setCustomerData((prevData) => ({
      ...prevData,
      Date: formattedDate,
      StartDate: currentDate,
      PaymentDate: nextMonthDate,
    }));
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setCustomerData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const calculateSpeechRemainingDays = () => {
    if (!customerData.SpeechEndDate || !customerData.SpeechIsActive) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const endDate = new Date(customerData.SpeechEndDate);
    endDate.setHours(0, 0, 0, 0);

    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  const calculateSpeechValue = () => {
    if (!customerData.SpeechStartDate || !customerData.SpeechIsActive || !customerData.SpeechPrice) {
      return null;
    }

    const startDate = new Date(customerData.SpeechStartDate);
    startDate.setHours(0, 0, 0, 0);

    // تحديد تاريخ النهاية (EndDate إذا كان موجود، وإلا اليوم)
    const endDate = customerData.SpeechEndDate ? new Date(customerData.SpeechEndDate) : new Date();
    endDate.setHours(0, 0, 0, 0);

    // إذا كان تاريخ النهاية في الماضي، لا تحسب القيمة
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (customerData.SpeechEndDate && endDate < today) {
      return null;
    }

    const price = parseFloat(customerData.SpeechPrice) || 0;
    let totalValue = 0;
    const monthDetails = [];

    // إذا كانا في نفس الشهر
    if (startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()) {
      const month = startDate.getMonth();
      const year = startDate.getFullYear();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const daysCount = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
      const dailyRate = price / daysInMonth;
      const monthValue = dailyRate * daysCount;
      totalValue = monthValue;
      
      monthDetails.push({
        month: month + 1,
        year: year,
        daysInMonth: daysInMonth,
        daysCount: daysCount,
        dailyRate: dailyRate,
        value: monthValue,
      });
    } else {
      // إذا كانا في شهرين مختلفين
      let currentDate = new Date(startDate);
      
      while (currentDate <= endDate) {
        const month = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        // تحديد أول يوم وآخر يوم في هذا الشهر
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        
        // تحديد تاريخ البداية الفعلي لهذا الشهر
        const monthStart = currentDate > firstDayOfMonth ? currentDate : firstDayOfMonth;
        
        // تحديد تاريخ النهاية الفعلي لهذا الشهر
        const monthEnd = endDate < lastDayOfMonth ? endDate : lastDayOfMonth;
        
        // حساب عدد الأيام في هذا الشهر
        const daysCount = Math.ceil((monthEnd - monthStart) / (1000 * 60 * 60 * 24)) + 1;
        
        // حساب القيمة لهذا الشهر
        const dailyRate = price / daysInMonth;
        const monthValue = dailyRate * daysCount;
        totalValue += monthValue;
        
        monthDetails.push({
          month: month + 1,
          year: year,
          daysInMonth: daysInMonth,
          daysCount: daysCount,
          dailyRate: dailyRate,
          value: monthValue,
        });
        
        // الانتقال إلى أول يوم من الشهر التالي
        currentDate = new Date(year, month + 1, 1);
      }
    }

    return {
      value: totalValue,
      monthDetails: monthDetails,
    };
  };

  const handleStartDateChange = (date, id) => {
    setCustomerData((prevData) => {
      const updatedData = {
        ...prevData,
        [id]: date,
      };
      
      // If PaymentDate is changed and SpeechIsActive is true, update SpeechEndDate
      if (id === "PaymentDate" && prevData.SpeechIsActive && date) {
        updatedData.SpeechEndDate = date instanceof Date ? new Date(date) : new Date(date);
      }
      
      return updatedData;
    });
  };

  const handleAddCustomer = async () => {
    confirmAlert({
      title: "Confirm",
      message: "Are you sure you want to add a new customer?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              // First, create information record
              const infoResponse = await instance.post(`information`, customerData);
              
              if (infoResponse.status !== 201) {
                toast.error("Error: Could not create information record.");
                return;
              }

              // Create other records in parallel
              const responses = await Promise.all([
                instance.post(`server`, customerData),
                instance.post(`system`, customerData),
                instance.post(`database`, customerData),
                instance.post(`app`, customerData),
                instance.post(`backup`, customerData),
                instance.post(`payment`, customerData),
              ]);

              const allSuccessful = responses.every(
                (response) => response.status === 201
              );

              // Create speech subscription using Code
              if (customerData.Code) {
                try {
                  const speechSubscriptionData = {
                    InformationCode: customerData.Code,
                    StartDate: customerData.SpeechStartDate instanceof Date 
                      ? customerData.SpeechStartDate.toISOString().split("T")[0]
                      : customerData.SpeechStartDate || null,
                    EndDate: customerData.SpeechEndDate instanceof Date
                      ? customerData.SpeechEndDate.toISOString().split("T")[0]
                      : customerData.SpeechEndDate || null,
                    IsActive: customerData.SpeechIsActive,
                    Price: customerData.SpeechPrice || "1000",
                  };
                  await instance.post(`speech-subscriptions/by-code/${customerData.Code}`, speechSubscriptionData);
                } catch (error) {
                  console.error("Error creating speech subscription:", error);
                  toast.error("Warning: Speech subscription could not be created.");
                }
              }

              if (allSuccessful) {
                toast.success("All data has been successfully added.");
                navigate("/");
              } else {
                toast.error("Error: Some data could not be added.");
              }
            } catch (error) {
              console.error("Error:", error);
              toast.error("An error occurred while adding the information.");
            }
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <div>
      <header>
        <h1>New Customer</h1>
      </header>
      <main>
        <div className="sidebar">
          <Link to="/" className="sidebar-button">
            ← Main
          </Link>
          {[
            { name: "Information", id: "information-section" },
            { name: "Server", id: "server-section" },
            { name: "System", id: "system-section" },
            { name: "Database", id: "database-section" },
            { name: "App", id: "app-section" },
            { name: "Backup", id: "backup-section" },
            { name: "Payment", id: "payment-section" },
            { name: "Speech", id: "speech-subscriptions-section" },
          ].map((section) => (
            <button
              key={section.name}
              onClick={() => scrollToSection(section.id)}
              className="sidebar-button"
            >
              {section.name}
            </button>
          ))}
        </div>

        <section id="information-section">
          <h2>Information</h2>
          <ul>
            <li>
              Date:
              <span className="info" id="date">
                {formattedDate}
              </span>
            </li>
            <li>
              <br />
              Code:
              <input
                className="input-field"
                type="text"
                id="Code"
                placeholder="Enter Code"
                value={customerData.Code}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Start Date:
              <DatePicker
                selected={customerData.StartDate}
                onChange={(date) => handleStartDateChange(date, "StartDate")}
                dateFormat="dd/MM/yyyy"
                className="input-field"
              />
            </li>
            <li>
              Name:
              <input
                className="input-field"
                type="text"
                id="Name"
                placeholder="Enter name"
                value={customerData.Name}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Name Owner:
              <input
                className="input-field"
                type="text"
                id="NameOwner"
                placeholder="Enter name owner"
                value={customerData.NameOwner}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Phone:
              <input
                className="input-field"
                type="text"
                id="Phone"
                placeholder="Enter phone number"
                value={customerData.Phone}
                onChange={handleInputChange}
              />
            </li>
            <li>
              City:
              <input
                className="input-field"
                type="text"
                id="City"
                placeholder="Enter city"
                value={customerData.City}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Governorate:
              <input
                className="input-field"
                type="text"
                id="Governorate"
                placeholder="Enter governorate"
                value={customerData.Governorate}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Wifi Name:
              <input
                className="input-field"
                type="text"
                id="WifiName"
                placeholder="Enter wifi name"
                value={customerData.WifiName}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Wifi Password:
              <input
                className="input-field"
                type={passwordVisibility.WifiPassword ? "text" : "password"}
                id="WifiPassword"
                placeholder="Enter wifi password"
                value={customerData.WifiPassword}
                onChange={handleInputChange}
              />
              <button
                className="show"
                onClick={() => togglePasswordVisibility("WifiPassword")}
              >
                {passwordVisibility.WifiPassword ? "Hide" : "Show"}
              </button>
            </li>
            <li>
              Latitude:
              <input
                className="input-field"
                type="number"
                step="any"
                id="Latitude"
                placeholder="Enter Latitude"
                value={customerData.Latitude}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Longitude:
              <input
                className="input-field"
                type="number"
                step="any"
                id="Longitude"
                placeholder="Enter Longitude"
                value={customerData.Longitude}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>
        <section id="server-section">
          <h2>Server</h2>
          <ul>
            <li>
              Server Status:
              <select
                className="input-field"
                id="ServerStatus"
                value={customerData.ServerStatus}
                onChange={handleInputChange}
              >
                <option value="New">New</option>
                <option value="Active">Active</option>
                <option value="Suspended">Suspended</option>
              </select>
            </li>
            <li>
              Management Site:
              <input
                className="input-field"
                type="text"
                id="ManagementSite"
                placeholder="Enter management site"
                value={customerData.ManagementSite}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Server Location:
              <input
                className="input-field"
                type="text"
                id="ServerLocation"
                placeholder="Enter server location"
                value={customerData.ServerLocation}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Name Server:
              <input
                className="input-field"
                type="text"
                id="NameServer"
                placeholder="Enter name server"
                value={customerData.NameServer}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Status:
              <select
                className="input-field"
                id="Status"
                value={customerData.Status}
                onChange={handleInputChange}
              >
                <option value="Online">Online</option>
                <option value="Offline">Offline</option>
                <option value="Maintenance">Maintenance</option>
              </select>
            </li>
            <li>
              Server Type:
              <select
                className="input-field"
                type="text"
                id="ServerType"
                placeholder="Enter server type"
                value={customerData.ServerType}
                onChange={handleInputChange}
              >
                <option value="Web Hosting">Web Hosting</option>
                <option value="Virtual Private Server Hosting">
                  Virtual Private Server Hosting
                </option>
                <option selected value="Dedicated Server Hosting">
                  Dedicated Server Hosting
                </option>
                <option value="Managed Hosting">Managed Hosting</option>
                <option value="Cloud Hosting">Cloud Hosting</option>
              </select>
            </li>
            <li>
              IP:
              <input
                className="input-field"
                type="text"
                id="IP"
                placeholder="Enter IP address"
                value={customerData.IP}
                onChange={handleInputChange}
              />
            </li>
            <li>
              IP VPN:
              <input
                className="input-field"
                type="text"
                id="IPVPN"
                placeholder="Enter IP VPN address"
                value={customerData.IPVPN}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>
        <section id="system-section">
          <h2>System</h2>
          <ul>
            <li>
              Server System:
              <input
                className="input-field"
                type="text"
                id="ServerSystem"
                placeholder="Enter server system"
                value={customerData.ServerSystem}
                onChange={handleInputChange}
              />
            </li>
            <li>
              User System:
              <input
                className="input-field"
                type="text"
                id="UserSystem"
                placeholder="Enter user system"
                value={customerData.UserSystem}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Password System:
              <input
                className="input-field"
                type={passwordVisibility.PasswordSystem ? "text" : "password"}
                id="PasswordSystem"
                placeholder="Enter password system"
                value={customerData.PasswordSystem}
                onChange={handleInputChange}
              />
              <button
                className="show"
                onClick={() => togglePasswordVisibility("PasswordSystem")}
              >
                {passwordVisibility.PasswordSystem ? "Hide" : "Show"}
              </button>
            </li>
            <li>
              Data Encryption:
              <select
                className="input-field"
                id="DataEncryption"
                value={customerData.DataEncryption}
                onChange={handleInputChange}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </li>
          </ul>
        </section>
        <section id="database-section">
          <h2>Database</h2>
          <ul>
            <li>
              Name Database:
              <input
                className="input-field"
                type="text"
                id="DatabaseName"
                placeholder="Enter name database"
                value={customerData.DatabaseName}
                onChange={handleInputChange}
              />
            </li>
            <li>
              SQL User:
              <input
                className="input-field"
                type="text"
                id="SQLUser"
                placeholder="Enter SQL user"
                value={customerData.SQLUser}
                onChange={handleInputChange}
              />
            </li>
            <li>
              SQL Password:
              <input
                className="input-field"
                type={passwordVisibility.PasswordSQL ? "text" : "password"}
                id="SQLPassword"
                placeholder="Enter SQL password"
                value={customerData.SQLPassword}
                onChange={handleInputChange}
              />
              <button
                className="show"
                onClick={() => togglePasswordVisibility("PasswordSQL")}
              >
                {passwordVisibility.PasswordSQL ? "Hide" : "Show"}
              </button>
            </li>
            <li>
              Trusted Connection:
              <select
                className="input-field"
                id="TrustedConnection"
                value={customerData.TrustedConnection}
                onChange={handleInputChange}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </li>
          </ul>
        </section>
        <section id="app-section">
          <h2>App</h2>
          <ul>
            <li>
              Version Back:
              <input
                className="input-field"
                type="text"
                id="VersionBack"
                placeholder="Enter version back"
                value={customerData.VersionBack}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Version Front:
              <input
                className="input-field"
                type="text"
                id="VersionFront"
                placeholder="Enter version front"
                value={customerData.VersionFront}
                onChange={handleInputChange}
              />
            </li>
            <li>
              URL Front:
              <input
                className="input-field"
                type="text"
                id="UrlFront"
                placeholder="Enter URL front"
                value={customerData.UrlFront}
                onChange={handleInputChange}
              />
            </li>
            <li>
              URL Back:
              <input
                className="input-field"
                type="text"
                id="UrlBack"
                placeholder="Enter URL back"
                value={customerData.UrlBack}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Super Admin:
              <input
                className="input-field"
                type="text"
                id="SuperAdmin"
                placeholder="Enter super admin"
                value={customerData.SuperAdmin}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Password Super Admin:
              <input
                className="input-field"
                type={
                  passwordVisibility.PasswordSuperAdmin ? "text" : "password"
                }
                id="PasswordSuperAdmin"
                placeholder="Enter super admin password"
                value={customerData.PasswordSuperAdmin}
                onChange={handleInputChange}
              />
              <button
                className="show"
                onClick={() => togglePasswordVisibility("PasswordSuperAdmin")}
              >
                {passwordVisibility.PasswordSuperAdmin ? "Hide" : "Show"}
              </button>
            </li>
          </ul>
        </section>
        <section id="backup-section">
          <h2>Backup</h2>
          <ul>
            <li>
              Backup Auto:
              <select
                className="input-field"
                id="BackupAuto"
                value={customerData.BackupAuto}
                onChange={handleInputChange}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </li>
            <li>
              Backup Manual Max Number:
              <input
                className="input-field"
                type="number"
                id="BackupManualMaxNumber"
                placeholder="Enter backup manual max number"
                value={customerData.BackupManualMaxNumber}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Backup Manual Path:
              <input
                className="input-field"
                type="text"
                id="BackupManualPath"
                placeholder="Enter backup manual path"
                value={customerData.BackupManualPath}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Backup Auto Path:
              <input
                className="input-field"
                type="text"
                id="BackupAutoPath"
                placeholder="Enter backup auto path"
                value={customerData.BackupAutoPath}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>
        <section id="payment-section">
          <h2>Payment Details</h2>
          <ul>
            <li>
              Price Type:
              <select
                className="input-field"
                type="text"
                id="PriceType"
                placeholder="Enter price type"
                value={customerData.PriceType}
                onChange={handleInputChange}
              >
                <option value="Bronze">Bronze</option>
                <option selected value="Silver">
                  Silver
                </option>
                <option value="Golden">Golden</option>
                <option value="Managed Hosting">Platinum</option>
                <option value="Diamond">Diamond</option>
              </select>
            </li>
            <li>
              Price:
              <input
                className="input-field"
                type="number"
                id="Price"
                placeholder="Enter price"
                value={customerData.Price}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Payment Date:
              <DatePicker
                selected={customerData.PaymentDate}
                onChange={(date) => handleStartDateChange(date, "PaymentDate")}
                dateFormat="dd/MM/yyyy"
                className="input-field"
              />
            </li>
            <li>
              System Price:
              <input
                className="input-field"
                type="text"
                id="SystemPrice"
                placeholder="Enter system price"
                value={customerData.SystemPrice}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Prepaid:
              <input
                className="input-field"
                type="number"
                id="Prepaid"
                placeholder="Enter prepaid amount"
                value={customerData.Prepaid}
                onChange={handleInputChange}
              />
            </li>
            <li>
              Monthly Fees:
              <input
                className="input-field"
                type="number"
                id="MonthlyFees"
                placeholder="Enter monthly fees"
                value={customerData.MonthlyFees}
                onChange={handleInputChange}
              />
            </li>
          </ul>
        </section>
        <section id="speech-subscriptions-section">
          <h2>Speech</h2>
          <ul>
            <li>
              Start Date:
              <DatePicker
                selected={customerData.SpeechStartDate}
                onChange={(date) => handleStartDateChange(date, "SpeechStartDate")}
                dateFormat="dd/MM/yyyy"
                className="input-field"
              />
            </li>
            <li>
              End Date:
              <DatePicker
                selected={customerData.SpeechEndDate}
                onChange={(date) => handleStartDateChange(date, "SpeechEndDate")}
                dateFormat="dd/MM/yyyy"
                className="input-field"
              />
            </li>
            <li>
              Is Active:
              <select
                className="input-field"
                id="SpeechIsActive"
                value={customerData.SpeechIsActive ? "true" : "false"}
                onChange={(e) => {
                  const isActive = e.target.value === "true";
                  setCustomerData((prevData) => {
                    const paymentDate = prevData.PaymentDate;
                    const hasPaymentDate = paymentDate && (paymentDate instanceof Date || paymentDate);
                    
                    return {
                      ...prevData,
                      SpeechIsActive: isActive,
                      SpeechStartDate: isActive ? new Date() : null,
                      SpeechEndDate: isActive && hasPaymentDate 
                        ? (paymentDate instanceof Date ? new Date(paymentDate) : new Date(paymentDate))
                        : null,
                    };
                  });
                }}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </li>
            <li>
              Price:
              <input
                className="input-field"
                type="number"
                id="SpeechPrice"
                placeholder="Enter speech subscription price"
                value={customerData.SpeechPrice}
                onChange={handleInputChange}
              />
            </li>
            <li>
              القيمة:{" "}
              <span
                className="info"
                style={{
                  background: "rgba(0, 150, 255, 0.3)",
                  fontWeight: "bold",
                }}
              >
                {(() => {
                  const valueData = calculateSpeechValue();
                  if (valueData === null) return "N/A";
                  
                  if (valueData.monthDetails.length === 1) {
                    const detail = valueData.monthDetails[0];
                    return `${valueData.value.toFixed(2)} (${detail.dailyRate.toFixed(2)} × ${detail.daysCount} يوم من ${detail.daysInMonth} يوم)`;
                  } else {
                    const detailsText = valueData.monthDetails.map((detail, index) => 
                      `الشهر ${index + 1}: ${detail.dailyRate.toFixed(2)} × ${detail.daysCount} يوم من ${detail.daysInMonth} يوم = ${detail.value.toFixed(2)}`
                    ).join(' | ');
                    return `${valueData.value.toFixed(2)} (${detailsText})`;
                  }
                })()}
              </span>
            </li>
            <li>
              Remaining:{" "}
              <span
                className="info"
                style={{
                  background: (() => {
                    const remaining = calculateSpeechRemainingDays();
                    if (remaining === null) return "rgba(128, 128, 128, 0.3)";
                    if (remaining < 0) return "rgba(255, 0, 0, 0.3)";
                    if (remaining <= 7) return "rgba(255, 165, 0, 0.3)";
                    return "rgba(0, 255, 0, 0.3)";
                  })(),
                }}
              >
                {(() => {
                  const remaining = calculateSpeechRemainingDays();
                  if (remaining === null) return "N/A";
                  if (remaining < 0) return `Expired (${Math.abs(remaining)} days ago)`;
                  return `${remaining} days`;
                })()}
              </span>
            </li>
          </ul>
        </section>
        <section id="notes-section">
          <h2>Notes</h2>
          <textarea
            className="input-field"
            id="Notes"
            placeholder="Enter notes"
            value={customerData.Notes}
            onChange={handleInputChange}
          ></textarea>
        </section>
        <button
          className="button3"
          id="addButtonNewCustomer"
          onClick={handleAddCustomer}
        >
          Add New Customer
        </button>
      </main>
    </div>
  );
};

export default NewCustomer;
// ----------------------------------------
// --------------------------------------------
